/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Root_HintInputs */

const cs_documents_root_hint = /** @type {(inputs: Documents_Root_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledejte, otevřete složku níže, nebo vytvořte kořenovou složku.`)
};

const en_documents_root_hint = /** @type {(inputs: Documents_Root_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search, open a folder below, or create a root folder to get started.`)
};

/**
* | output |
* | --- |
* | "Search, open a folder below, or create a root folder to get started." |
*
* @param {Documents_Root_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_root_hint = /** @type {((inputs?: Documents_Root_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Root_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_root_hint(inputs)
	return cs_documents_root_hint(inputs)
});